import PublicFanLivesPage from "./PublicFanLivesPage";

export default PublicFanLivesPage;
